<div
  class="indexes foreignexchanges"
  style="padding-top: 1.5em"
  *ngIf="orientation === 'vertical'"
>
  <div class="row center-xs title">
    <div class="col-xs-4 start-xs no-padding">
      <span class="title-sec">Divisa</span>
    </div>
    <div class="col-xs-3 end-xs no-padding">
      <span class="title-sec">Último</span>
    </div>
    <div class="col-xs-3 end-xs no-padding">
      <span class="title-sec">Cambio</span>
    </div>
    <div class="col-xs-2 end-xs no-padding">
      <span class="title-sec">%</span>
    </div>
  </div>
  <div class="skeleton-view" *ngIf="skeleton">
    <div class="row" *ngFor="let number of [0, 1, 2, 3, 4, 5]">
      <div class="col-xs-3 start-xs no-padding ellipsis">
        <span class="skeleton"></span>
      </div>
      <div class="col-xs-3 end-xs no-padding">
        <span class="skeleton"></span>
      </div>
      <div class="col-xs-3 end-xs no-padding">
        <span class="skeleton"></span>
      </div>
      <div class="col-xs-3 end-xs no-padding">
        <span class="skeleton"></span>
      </div>
    </div>
  </div>
  <div class="exchange-container" *ngIf="!skeleton">
    <div
      class="row"
      *ngFor="let i of foreignexchanges"
      [class.selected]="currentIndex === i.name"
      [class.hover-neutro]="
        i.calculatedPercentageChange === 0 || i.isPlaceholder
      "
      [class.hover-positive]="i.calculatedPercentageChange > 0"
      [class.hover-negative]="i.calculatedPercentageChange < 0"
    >
      <div class="row-container" *ngIf="!i.isPlaceholder">
        <div class="col-xs-4 no-padding ellipsis">
          <span>
            <div
              class="icon"
              [class.icon-arrow-cero]="i.calculatedPercentageChange === 0"
              [class.icon-arrow-sube]="i.calculatedPercentageChange > 0"
              [class.icon-arrow-baja]="i.calculatedPercentageChange < 0"
              [class.neutro]="i.calculatedPercentageChange === 0"
              [class.positive]="i.calculatedPercentageChange > 0"
              [class.negative]="i.calculatedPercentageChange < 0"
            ></div>
          </span>
          <span class="name">
            {{ i.realName }}
          </span>
        </div>
        <div class="col-xs-3 end-xs no-padding">
          <span [innerHTML]="i.currencySymbol"></span>
          <span class="number" *ngIf="i.calculatedValue < 1">
            {{ i.calculatedValue | hbCustomFormat: '0,0.0000' }}
          </span>
          <span class="number" *ngIf="i.calculatedValue >= 1">
            {{ i.calculatedValue | hbCustomFormat: '0,0.00' }}
          </span>
        </div>
        <div class="col-xs-3 end-xs no-padding">
          <span
            class="number"
            *ngIf="i.calculatedUnitChange < 1 && foreignexchange === 'mxn'"
          >
            {{ i.calculatedUnitChange | hbCustomFormat: '$0,0.000000' }}
          </span>
          <span
            class="number"
            *ngIf="i.calculatedUnitChange < 1 && foreignexchange !== 'mxn'"
          >
            ${{ i.calculatedUnitChange }}
          </span>
          <span class="number" *ngIf="i.calculatedUnitChange >= 1">
            {{ i.calculatedUnitChange | hbCustomFormat: '$0,0.0000' }}
          </span>
        </div>
        <div class="col-xs-2 end-xs no-padding">
          <span
            class="number"
            [class.neutro]="i.calculatedPercentageChange === 0"
            [class.positive]="i.calculatedPercentageChange > 0"
            [class.negative]="i.calculatedPercentageChange < 0"
          >
            {{ i.calculatedPercentageChange | hbCustomFormat: '0,0.000%' }}
          </span>
        </div>
      </div>
      <div class="row-container" *ngIf="i.isPlaceholder">
        <div class="col-xs-4 no-padding ellipsis">
          <span>
            <div class="icon icon-arrow-cero neutro"></div>
          </span>
          <span class="name">
            {{ i.realName }}
          </span>
        </div>
        <div class="col-xs-3 end-xs no-padding">
          <span class="number"> -- </span>
        </div>
        <div class="col-xs-3 end-xs no-padding">
          <span class="number"> -- </span>
        </div>
        <div class="col-xs-2 end-xs no-padding">
          <span class="number neutro"> -- </span>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="horizontal-foreignexchange" *ngIf="orientation === 'horizontal'">
  <div class="row indexes-row spacing" *ngFor="let i of foreignexchanges">
    <span
      class="name"
      [class.second-foreign-exchange]="i.realName === 'EUR/MXN'"
      [class.third-foreign-exchange]="i.realName === 'JPY/MXN'"
      [class.fourth-foreign-exchange]="i.realName === 'GBP/MXN'"
    >
      {{ i.realName }}
    </span>
    <span
      [innerHTML]="i.currencySymbol"
      [class.second-foreign-exchange]="i.realName === 'EUR/MXN'"
      [class.third-foreign-exchange]="i.realName === 'JPY/MXN'"
      [class.fourth-foreign-exchange]="i.realName === 'GBP/MXN'"
    >
    </span>
    <span
      class="number symbol"
      [class.second-foreign-exchange]="i.realName === 'EUR/MXN'"
      [class.third-foreign-exchange]="i.realName === 'JPY/MXN'"
      [class.fourth-foreign-exchange]="i.realName === 'GBP/MXN'"
    >
      {{ i.calculatedValue | hbCustomFormat: '0,0.00' }}
    </span>
  </div>
</div>
